import { buildProps } from '@lit-element/utils'
import type { ExtractPropTypes } from 'vue'
import type split from './split.vue'

export const splitProps = buildProps({
  /**
   * @description 分割方向
   */
  orientation: {
    type: String,
    default: 'horizontal',
    validator: (value) => ['horizontal', 'vertical'].includes(value),
  },
  /**
   * @description 面板占比
   */
  initialRatio: {
    type: Number,
    default: 0.5,
    validator: (value) => value >= 0 && value <= 1,
  },
  /**
   * @description 是否全屏
   */
  canfull: {
    type: Boolean,
    default: false,
  },
  lazy: {
    type: Boolean,
    default: false,
  },
} as const)
export type SplitProps = ExtractPropTypes<typeof splitProps>
export type SplitInstance = InstanceType<typeof split>
